import { useState, useRef, useEffect } from 'react'

import useOnClickOutside from './useOnClickOutside'

const useDropdown = (initialState = false, { onClose = () => {} } = {}) => {
  const [isOpen, setIsOpen] = useState(initialState)
  const dropdownRef = useRef(null)

  const handleOpen = () => setIsOpen(true)

  const handleClose = () => {
    setIsOpen(false)
    onClose()
  }

  const handleCloseOnKeyPress = (event) => {
    if (event.key === 'Escape') {
      setIsOpen(false)
      onClose()
    }
  }

  const handleToggle = () => setIsOpen((prev) => !prev)

  useOnClickOutside(dropdownRef, handleClose)

  useEffect(() => {
    window.addEventListener('keydown', handleCloseOnKeyPress)

    return () => {
      window.removeEventListener('keydown', handleCloseOnKeyPress)
    }
  }, [])

  return { isOpen, handleOpen, handleClose, handleToggle, dropdownRef }
}

export default useDropdown
